if (!customElements.get('split-promo-slider')) {
  class SplitPromoSlider extends HTMLElement {
    constructor() {
      super();

      if (window.Shopify && Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => {
          this.mountSlider();
        });
      }

      this.mountSlider();

      window.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) {
          return;
        }

        const selectedSlideIndex = Number(e.target.dataset.index);

        if (this.slider && !Number.isNaN(selectedSlideIndex)) {
          this.slider.slideTo(selectedSlideIndex, 600);
        }
      });
    }

    mountSlider() {
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const autoplayEnabled =
        this.dataset.autoplay === 'true' && !prefersReducedMotion;

      const paginationEl = this.querySelector('.swiper-pagination');

      this.slider = new Swiper(this, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : false,
        autoplay: autoplayEnabled
          ? {
              delay: Number(this.dataset.autoplayInterval)
            }
          : false
      });
    }
  }

  customElements.define('split-promo-slider', SplitPromoSlider);
}
